import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Programs", path: "/programs" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav className="sticky top-0 z-40 w-full border-b border-border bg-[#E8E8E8] dark:bg-card">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img src={logo} alt="Catalyst Consulting & Design" className="h-12 w-12" width="500" height="500" />
            <span className="text-lg font-bold text-foreground hidden sm:block">
              Catalyst Consulting & Design
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
              >
                {link.name}
              </Link>
            ))}
            <Link to="/request-quote">
              <Button variant="outline" size="sm">
                Request Quote
              </Button>
            </Link>
            <Link to="/catalyst-start">
              <Button size="sm" variant="hero">
                🚀 Catalyst Start
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-2 animate-in slide-in-from-top">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="block py-2 text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/request-quote"
              onClick={() => setIsOpen(false)}
              className="block py-2 text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
            >
              Request Quote
            </Link>
            <Link
              to="/catalyst-start"
              onClick={() => setIsOpen(false)}
              className="block py-2 text-sm font-medium text-primary font-semibold transition-colors"
            >
              🚀 Catalyst Start — Coming Soon
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};
